import { IKIBusinessPriority } from 'legacy/lut/features/partner360/jbpSettings/models/kiBusinessPriority'

export const getBusinessPriorityNames = (
  businessPriorities: IKIBusinessPriority[],
  value?: string | null
): string[] => {
  if (!value) {
    return []
  }

  const priorityMap = new Map(businessPriorities.map((item) => [item.uid.toLowerCase(), item.name]))

  return value
    .split(',')
    .map((uid) => priorityMap.get(uid.trim().toLowerCase()))
    .filter((name): name is string => Boolean(name))
}
